//@flow
import * as React from 'react';

import { Route, Switch } from 'react-router-dom';
import ReprocessarIntegracoesPage from './ReprocessarIntegracoesPage';

export default class ReprocessarIntegracoes extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/reprocessarIntegracoes"
            exact
            component={ReprocessarIntegracoesPage}
          />
        </Switch>
      </React.Fragment>
    );
  }
}
